import { FormattedMessage } from 'react-intl';

import {
  MAX_NAME_LENGTH,
  MAX_EMAIL_LENGTH,
  MAX_PHONE_LENGTH,
  MAX_TEXT_FIELD_LENGTH,
  withPasswordValidation,
  withPersonNameValidation,
  withPhoneNumberValidation,
} from '@/shared/config';
import { boolean, InferType, object, string, ref } from '@/shared/config/yup';

export const signUpFormSchema = object({
  email: string().email().required().max(MAX_EMAIL_LENGTH),
  confirmEmail: string()
    .oneOf([ref('email')], () => (
      <FormattedMessage
        id="signUp.emailsMustMatch"
        defaultMessage="Emails must match"
      />
    ))
    .required()
    .max(MAX_EMAIL_LENGTH),
  password: string().optional().max(MAX_TEXT_FIELD_LENGTH),
  confirmPassword: string()
    .oneOf([ref('password')], () => (
      <FormattedMessage
        id="signUp.passwordsMustMatch"
        defaultMessage="Passwords must match"
      />
    ))
    .optional()
    .max(MAX_TEXT_FIELD_LENGTH),
  firstName: withPersonNameValidation(string()).required().max(MAX_NAME_LENGTH),
  lastName: withPersonNameValidation(string()).required().max(MAX_NAME_LENGTH),
  language: string().required(),
  country: string().required(),
  phoneNumber: withPhoneNumberValidation(string())
    .optional()
    .max(MAX_PHONE_LENGTH),
  firstAgreements: boolean().oneOf([true]).required(),
  secondAgreements: boolean().oneOf([true]).required(),
  marketingCommunicationConsent: boolean(),
});

export type SignUpFormPayload = InferType<typeof signUpFormSchema>;

export const signUpViaOrganizationInviteFormSchema = object({
  email: string().email().optional().max(MAX_EMAIL_LENGTH),
  confirmEmail: string()
    .oneOf([ref('email')], () => (
      <FormattedMessage
        id="signUp.emailsMustMatch"
        defaultMessage="Emails must match"
      />
    ))
    .optional()
    .max(MAX_EMAIL_LENGTH),
  password: withPasswordValidation(string().required()),
  confirmPassword: string()
    .oneOf([ref('password')], () => (
      <FormattedMessage
        id="signUp.passwordsMustMatch"
        defaultMessage="Passwords must match"
      />
    ))
    .required(),
  firstName: withPersonNameValidation(string()).required().max(MAX_NAME_LENGTH),
  lastName: withPersonNameValidation(string()).required().max(MAX_NAME_LENGTH),
  language: string().required(),
  country: string().optional(),
  phoneNumber: withPhoneNumberValidation(string())
    .optional()
    .max(MAX_PHONE_LENGTH),
  firstAgreements: boolean().oneOf([true]).required(),
  secondAgreements: boolean().oneOf([true]).required(),
  marketingCommunicationConsent: boolean(),
});

export type SignUpViaOrganizationInvitePayload = InferType<
  typeof signUpViaOrganizationInviteFormSchema
>;

export const signUpViaSharedPatientFormSchema = object({
  email: string().email().optional().max(MAX_EMAIL_LENGTH),
  confirmEmail: string()
    .oneOf([ref('email')], () => (
      <FormattedMessage
        id="signUp.emailsMustMatch"
        defaultMessage="Emails must match"
      />
    ))
    .optional()
    .max(MAX_EMAIL_LENGTH),
  password: withPasswordValidation(string().required()),
  confirmPassword: string()
    .oneOf([ref('password')], () => (
      <FormattedMessage
        id="signUp.passwordsMustMatch"
        defaultMessage="Passwords must match"
      />
    ))
    .required(),
  firstName: withPersonNameValidation(string()).required().max(MAX_NAME_LENGTH),
  lastName: withPersonNameValidation(string()).required().max(MAX_NAME_LENGTH),
  language: string().required(),
  country: string().required(),
  phoneNumber: withPhoneNumberValidation(string())
    .optional()
    .max(MAX_PHONE_LENGTH),
  firstAgreements: boolean().oneOf([true]).required(),
  secondAgreements: boolean().oneOf([true]).required(),
  marketingCommunicationConsent: boolean(),
});

export type SignUpViaSharedPatientPayload = InferType<
  typeof signUpViaOrganizationInviteFormSchema
>;
